import { render, staticRenderFns } from "./DepartureTabsBooking.vue?vue&type=template&id=d8bec85e&scoped=true&"
import script from "./DepartureTabsBooking.vue?vue&type=script&lang=js&"
export * from "./DepartureTabsBooking.vue?vue&type=script&lang=js&"
import style0 from "./DepartureTabsBooking.vue?vue&type=style&index=0&id=d8bec85e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8bec85e",
  null
  
)

export default component.exports